<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      <div class="headline">{{ labels.vesVoyDets }}</div>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex lg4 xs12>
            <v-text-field v-model="vesVoyForm.vesNo" :label="labels.vesNo" disabled></v-text-field>
          </v-flex>
          <v-flex lg8 xs12>
            <!-- <v-text-field v-model="vesVoyForm.vesName" :label="labels.vesName" :error-messages="errors.collect('vesName')" data-vv-name="vesName" :data-vv-as="labels.vesName" v-validate="'required|max:80'"></v-text-field> -->
            <v-text-field v-model="vesVoyForm.vesName" :label="labels.vesName" disabled></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="vesVoyForm.voyDet"
              :label="labels.voyDet"
              :error-messages="errors.collect('voyDet')"
              data-vv-name="voyDet"
              :data-vv-as="labels.voyDet"
              v-validate="'required|max:120'"
            ></v-text-field>
          </v-flex>
          <v-flex lg4 xs12>
            <cal-picker
              v-model="vesVoyForm.estDeptDate"
              :label="labels.estDeptDate"
              v-validate="'required'"
              :data-vv-as="labels.estDeptDate"
              data-vv-name="estDeptDate"
              :error-messages="errors.collect('estDeptDate')"
            ></cal-picker>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn v-on="on" color="green" dark @click="closeDialog" :loading="vesVoyDetsLoading">
        <v-icon dark left>mdi-arrow-left-bold</v-icon> {{ labels.exit }}
      </v-btn>
      <v-btn v-on="on" color="blue" dark @click="doSaveVesVoyDets" :loading="vesVoyDetsLoading">
        <v-icon dark left>mdi-content-save</v-icon> {{ labels.save }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
export default {
  data() {
    return {
      labels: {
        vesVoyDets: 'Vessel Voyage Detail',
        vesNo: 'Vessel No.',
        vesName: 'Vessel Name',
        voyDet: 'Voyage Detail',
        estDeptDate: 'Estimate Departure Date',
        exit: 'Exit',
        save: 'Save'
      },
      vesVoyForm: {
        vesNo: undefined,
        vesName: undefined,
        voyDet: undefined,
        estDeptDate: undefined
      },
      autoCreateVesselVoyageDialog: false,
      vesVoyDetsLoading: false
    }
  },
  watch: {
    vesNo: function (value) {
      this.vesVoyForm.vesNo = value
    },
    vesName: function (value) {
      this.vesVoyForm.vesName = value
    }
  },
  methods: {
    doInit() {
      this.vesVoyForm.vesNo = this.vesNo
      this.vesVoyForm.vesName = this.vesName
      this.vesVoyForm.voyDet = undefined
      this.vesVoyForm.estDeptDate = undefined
    },
    closeDialog() {
      this.$emit('close')
    },
    doSaveVesVoyDets() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          const apiURI = this.$store.state.marineParam.menu.saveVslVoy
          if (apiURI) {
            this.vesVoyDetsLoading = true
            this.$http
              .post(apiURI, this.vesVoyForm)
              .then((result) => {
                const { data } = result
                if (data) {
                  this.notify(data)
                  this.vesVoyDetsLoading = false
                  this.$emit('loadVesNo')
                  this.doInit()
                  this.closeDialog()
                }
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
                this.vesVoyDetsLoading = false
              })
          } else {
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  props: {
    vesNo: {
      type: String
    },
    vesName: {
      type: String
    }
  },
  beforeMount() {
    if (this.$store.state.marineParam.init !== 1) {
      this.$store.dispatch('marineManagementInit')
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [commonAjaxMixin]
}
</script>

<style>
</style>
